/* eslint-disable no-useless-escape */
import {
  getStorageItem,
  setStorageItem,
  delStorageItem,
} from "@/utils/storage";
import { SHA1 } from "crypto-js";

export const LoginTokenKey = "report-warlock-login-token";
export const tokenKey = "syszyypt_report_token";

const AccessUserKey = "warlockUser";

let client = null;
let antiRepeatToken = "";
let lastAntiRepeatToken = ""; //上一次的值

export const getClientHeader = () => {
  // let warlockiToken = localStorage.getItem("warlock-token");
  // let tokenStr = localStorage.getItem(LoginTokenKey);
  // if (warlockiToken == null || client == null || tokenStr == null) {
    // client = {};
    // client.type = "warlock-pc";
    // client.token = tokenStr;
    // localStorage.setItem("warlock-token", client.token);
    // client.sign = SHA1(client.type + "_" + "123_" + client.token + "_!@#");
  // }

   let warlockiToken = localStorage.getItem(tokenKey);
  if (warlockiToken == null || client == null) {
    client = {};
    client.type = "warlock-pc";
    client.token = randomString(32);
    localStorage.setItem(tokenKey, client.token);
    client.sign = SHA1(client.type + "_" + "123_" + client.token + "_!@#");
  }
  return client;
};
export const getAntiRepeat = () => {
  return {
    antiRepeatToken: antiRepeatToken,
    lastAntiRepeatToken: lastAntiRepeatToken,
  };
};
export const saveAntiRepeat = (obj) => {
  (Object.keys(obj) || []).forEach((e) => {
    if (e == "antiRepeatToken") {
      antiRepeatToken = obj[e];
    } else if (e == "lastAntiRepeatToken") {
      lastAntiRepeatToken = obj[e];
    }
  });
};

export function getLoginToken() {
  return getStorageItem(LoginTokenKey);
}

export function setLoginToken(token) {
  return setStorageItem(LoginTokenKey, token);
}

export function delLoginToken() {
  return delStorageItem(LoginTokenKey);
}

export function getAccessUser() {
  return getStorageItem(AccessUserKey);
}
export function setAccessUser(accessUser) {
  return setStorageItem(AccessUserKey, accessUser);
}
export function delAccessUser() {
  return delStorageItem(AccessUserKey);
}

// 获取当前用户的所有的权限码，判断是否有
export function hasPermission(permissionStr) {
  // 不需要权限
  if (permissionStr == null || permissionStr.length == 0) {
    return true;
  }

  // 登录用户的全部权限码
  let user = getAccessUser();
  if (user == null || user.authorities == null) {
    return false;
  }
  let opAuthoritiesStr = JSON.stringify(user.authorities);

  // permissionStr可能是：authorityManage、authorityManage:insert、authorityManage:insert|authorityManage:update
  let needPermissionArray = permissionStr.split("|");
  for (let i = 0; i < needPermissionArray.length; i++) {
    // 只要有其中的一个权限，就返回true
    let needPermission = needPermissionArray[i]; // authorityManage、authorityManage:insert
    needPermission = needPermission.replace(/\ /g, ""); // 去除authorityManage : insert中:前后的空格

    if (opAuthoritiesStr.indexOf(needPermission) >= 0) {
      return true;
    }
  }
  return false;
}

export const randomString = (length = 32, strs) => {
  var str =
    strs ?? "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var result = "";
  for (var i = length; i > 0; --i) {
    result += str[Math.floor(Math.random() * str.length)];
  }
  return result;
};
